module.exports = __webpack_public_path__ + "img/consultation@2x.1d42140.webp";